import React from 'react';
import { MathJax } from 'better-react-mathjax';

function MathTextRenderer({ text }) {
  if (!text) {
    return null;
  }

  const parts = [];
  let lastIndex = 0;
  
  // Define all possible math delimiters
  const delimiters = [
    { start: '\\(', end: '\\)' },
    { start: '$', end: '$' }
  ];

  // Find the next math delimiter in the text
  const findNextDelimiter = (startFrom) => {
    let earliestStart = -1;
    let earliestEnd = -1;
    let currentDelimiter = null;

    for (const delimiter of delimiters) {
      const startIndex = text.indexOf(delimiter.start, startFrom);
      if (startIndex !== -1 && (earliestStart === -1 || startIndex < earliestStart)) {
        const endIndex = text.indexOf(delimiter.end, startIndex + delimiter.start.length);
        if (endIndex !== -1) {
          earliestStart = startIndex;
          earliestEnd = endIndex;
          currentDelimiter = delimiter;
        }
      }
    }

    return { startIndex: earliestStart, endIndex: earliestEnd, delimiter: currentDelimiter };
  };

  let { startIndex, endIndex, delimiter } = findNextDelimiter(0);

  while (startIndex !== -1 && endIndex !== -1) {
    // Add the text before the math delimiter
    if (startIndex > lastIndex) {
      parts.push({ type: 'text', content: text.substring(lastIndex, startIndex) });
    }

    // Add the math content (including delimiters for MathJax processing)
    const mathContent = text.substring(startIndex, endIndex + delimiter.end.length);
    parts.push({ type: 'math', content: mathContent });

    // Move to the next part
    lastIndex = endIndex + delimiter.end.length;
    ({ startIndex, endIndex, delimiter } = findNextDelimiter(lastIndex));
  }

  // Add any remaining text after the last math delimiter
  if (lastIndex < text.length) {
    parts.push({ type: 'text', content: text.substring(lastIndex) });
  }

  return (
    <>
      {parts.map((part, index) => {
        if (part.type === 'math') {
          return <MathJax key={index} inline={true}>{part.content}</MathJax>;
        } else {
          return <span key={index}>{part.content}</span>;
        }
      })}
    </>
  );
}

export default MathTextRenderer;